<template>
  <section>
    <notifications></notifications>
    <sidebar-help
      :title="$route.meta.title"
      :items="guides"
      :loader="loader"
      :toggleSidebar="visibleSideBar"
      @closeSidebar="closeSidebar"
    />
    <base-header>
      <div class="row align-items-center">
        <div class="col-lg-4 col-md-6 col-sm-6 col-5 d-flex align-items-center">
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>
          <h1 class="title-view">{{ $route.meta.title }}</h1>
        </div>
        <div class="col-lg-8 col-md-6 col-sm-6 col-7 text-right">
          <div class="box-buttons">
            <base-button
              v-if="selectedRows.length > 0 && canUserDelete"
              type="outline-neutral"
              class="min-button btn-line-danger mr-2"
              @click="deleteMany()"
            >
              <i class="flaticon-delete icon-no-margin"></i>
              <strong class="d-lg-block d-none">Delete</strong>
            </base-button>

            <base-button
              v-if="canUserCreate"
              type="primary"
              @click="$router.push('/customers/new')"
              class="min-button"
            >
              <i class="flaticon-plus"></i>New
              <strong class="d-lg-block d-none ml-1"> Customer</strong>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid forms mb-5">
      <div class="main-buttons">
        <div class="row">
          <div
            class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 align-self-center mb-0"
          >
            <b-form-group class="mb-0">
              <b-input-group size="sm" class="input-search">
                <b-input-group-prepend class="pt-1 pl-1">
                  <i class="flaticon-bold-magnifier"></i>
                </b-input-group-prepend>
                <b-form-input
                  id="filter-input"
                  v-model.trim="simpleSearch"
                  v-on:input="applySimpleSearch"
                  type="search"
                  placeholder="Search Anything..."
                  class="border-none"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </div>
          <div
            class="col-xl-8 col-lg-8 col-md-6 col-sm-6 col-12 alinmov2 align-self-center"
          >
            <div>
              <div class="box-buttons">
                <base-dropdown
                  menu-on-right
                  class="nav-item"
                  tag="li"
                  title-tag="a"
                  title-classes="btn min-button btn-outline-neutral "
                  title="Actions"
                >
                  <base-button slot="title" type="none" class="p-0 min-button">
                    <i class="flaticon-employees"></i>
                    <strong>Customer Type</strong>
                  </base-button>

                  <div
                    class="dropdown-item"
                    :class="customerType === 'all' ? 'active' : ''"
                    @click="typeSearch('all')"
                  >
                    All
                  </div>

                  <div
                    class="dropdown-item"
                    :class="customerType === 'business' ? 'active' : ''"
                    @click="typeSearch('business')"
                  >
                    Business
                  </div>

                  <div
                    class="dropdown-item"
                    :class="customerType === 'customer' ? 'active' : ''"
                    @click="typeSearch('customer')"
                  >
                    Customer
                  </div>
                  <div
                    class="dropdown-item"
                    :class="customerType === 'guest' ? 'active' : ''"
                    @click="typeSearch('guest')"
                  >
                    Guest
                  </div>
                </base-dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="box-table">
        <div class="row">
          <div
            class="col-xl-3 col-lg-4 col-md-5 col-sm-5 col-12 align-self-center"
          ></div>

          <div
            class="col-xl-9 col-lg-8 col-md-12 col-sm-12 col-12 order-lg-2 order-md-1 order-sm-1 order-1 text-right mb-1"
          >
            <div
              class="col-xl-7 col-lg-12 col-md-6 ml-auto d-inline-block mb-xl-0"
            >
              <b-form-group
                label="Sort"
                label-for="sort-by-select"
                label-cols-sm="2"
                label-align-sm="right"
                label-size="sm"
                v-slot="{ ariaDescribedby }"
                class="mb-2"
                size="sm"
              >
                <b-input-group>
                  <b-form-select
                    id="sort-by-select"
                    v-model="sortBy"
                    :options="sortOptions"
                    :aria-describedby="ariaDescribedby"
                    @change="applySortBy"
                    class="w-70"
                    size="sm"
                  >
                    <template #first>
                      <option value="">-- None --</option>
                    </template>
                  </b-form-select>

                  <b-form-select
                    v-model="sortDesc"
                    :disabled="!sortBy"
                    @change="applySortType"
                    :aria-describedby="ariaDescribedby"
                    class="w-30"
                    size="sm"
                  >
                    <option :value="'asc'">Asc</option>
                    <option :value="'desc'">Desc</option>
                  </b-form-select>
                </b-input-group>
              </b-form-group>
            </div>

            <div class="d-inline-block mr-2 mb-2">
              <b-form-group v-slot="{ ariaDescribedbyview }" class="mb-0">
                <b-form-radio-group
                  id="btn-radios-view"
                  v-model="view"
                  :aria-describedby="ariaDescribedbyview"
                  name="radios-btn-default"
                  buttons
                  @change="changeViewCard"
                  class="mb-0"
                  button-variant="outline-neutral pc-3"
                >
                  <b-form-radio value="table"
                    ><i class="flaticon-two" title="View Table"></i
                  ></b-form-radio>
                  <b-form-radio value="card"
                    ><i class="flaticon-menu" title="View Card"></i
                  ></b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </div>
            <div v-if="canUserExport" class="d-inline-block mr-2 mb-2">
              <el-tooltip content="Export" placement="bottom">
                <base-dropdown
                  menu-on-right
                  class="nav-item"
                  tag="div"
                  title-tag="a"
                  title-classes="btn btn-outline-neutral btn-icon-only m-0 dropnocaret"
                  title="Export"
                >
                  <base-button
                    slot="title"
                    type="none"
                    class="pl-0 pr-0 icon-only"
                  >
                    <i class="flaticon-downloading-files mr-0 "></i>
                  </base-button>

                  <div
                    class="dropdown-item"
                    @click="download(selectedRows)"
                    v-if="selectedRows.length > 0"
                  >
                    Selected Records
                  </div>
                  <div class="dropdown-item" @click="download([])">
                    All Records
                  </div>
                </base-dropdown>
              </el-tooltip>
            </div>
            <div class="d-inline-block">
              <el-tooltip content="Help" placement="bottom">
                <base-button
                  type="outline-neutral"
                  class="btn-icon-only mb-0"
                  @click="openSideBar"
                >
                  <i class="flaticon-question-1 f-16 mr-0"></i>
                </base-button>
              </el-tooltip>
            </div>
          </div>
        </div>

        <pagination-block
          :pageCount="customerResponse.pages"
          :total="customerResponse.count"
          v-model="currentPage"
          :limit="limit"
          @changeLimit="changeLimit"
          @changePage="changePage"
          @nextPage="nextPaginations"
          @prevPage="previousPaginations"
          position="bottom"
        ></pagination-block>

        <b-table
          hover
          :items="customers"
          :fields="fields"
          sort-by.sync="created_at"
          sort-asc.sync="true"
          selectable
          @row-selected="onRowSelected"
          select-mode="multi"
          ref="selectableTable"
          sort-icon-left
          responsive
          show-empty
          empty-filtered-text="There are no records matching your request"
          empty-text="There are no records to show"
          :stacked="cardview"
        >
          <template #head()="{ label, field: { key } }">
            <span v-if="key === 'selected'">
              <span
                @click="clearSelected"
                v-if="selectedRows.length == customers.length"
                class="check-table selected"
              ></span>

              <span @click="selectAllRows" v-else class="check-table"></span>
            </span>
            <span v-else>{{ label }}</span>
          </template>
          <template #cell(selected)="{ rowSelected }">
            <template v-if="rowSelected">
              <span aria-hidden="true" class="check-table selected"></span>
              <span class="sr-only">Selected</span>
            </template>
            <template v-else>
              <span aria-hidden="true" class="check-table"></span>
              <span class="sr-only">Not selected</span>
            </template>
          </template>

          <template #thead-top=""> </template>

          <template #cell(first_name)="data">
            <div class="d-flex align-items-center">
              <div class="d-inline-flex">
                <el-tooltip
                  content="Confirmed"
                  placement="bottom"
                  v-if="data.item.status"
                >
                  <i
                    class="flaticon-check-2 text-success d-inline-flex mr-2 f2"
                  ></i>
                </el-tooltip>

                <el-tooltip v-else content="No Confirmed" placement="bottom">
                  <i
                    class="flaticon-check-2 text-danger d-inline-flex mr-2 f2"
                  ></i>
                </el-tooltip>
              </div>

              <div class="d-inline-flex">
                <div v-if="['business'].indexOf(data.item.type) > -1">
                  <span class="role-table capitalize">
                    {{ data.item.first_name }} {{ data.item.last_name }}
                  </span>
                  <router-link
                    class="capitalize hide-data"
                    :to="`/customers/${data.item._id}`"
                    >{{ data.item.company_name }}</router-link
                  >
                </div>
                <div v-else>
                  <router-link
                    class="capitalize hide-data"
                    :to="`/customers/${data.item._id}`"
                    >{{ data.item.first_name }}
                    {{ data.item.last_name }}</router-link
                  >
                </div>
              </div>
              <el-tooltip
                content="See Agents"
                placement="bottom"
                v-if="data.item.type === 'travel_agency'"
              >
                <div class="icon-action ml-2" @click="seeAgents(data.item)">
                  <span class="icon-action">
                    <i
                      class="flaticon-up-1"
                      :class="addArrowActionClass(data.item.agents)"
                      v-if="data.item._showDetails"
                    >
                    </i>
                    <i
                      class="flaticon-down-1"
                      :class="addArrowActionClass(data.item.agents)"
                      v-else
                    >
                    </i>
                  </span>
                </div>
              </el-tooltip>
              <div
                class="d-inline-flex ml-2 f2"
                v-if="
                  data.item.invite === 'PENDING' && data.item.type === 'guest'
                "
              >
                <el-tooltip content="Invited as Partner" placement="bottom">
                  <i
                    class="flaticon-support text-warning d-inline-flex mr-2 f2"
                  ></i>
                </el-tooltip>
              </div>
            </div>
          </template>

          <template #row-details="data">
            <Agents
              :agencyId="data.item._id"
              :collections="data.item.agents ? data.item.agents : []"
            />
          </template>

          <template #cell(type)="data">
            <span class="text-capitalize">{{ data.item.type | typeUser }}</span>
          </template>

          <template #cell(gender)="data">
            <span class="capitalize">{{
              data.item.gender | formatGender
            }}</span>
          </template>

          <template #cell(country)="data">
            <span class="capitalize" v-if="data.item.country">{{
              data.item.country
            }}</span>
            <span v-else>--</span>
          </template>

          <template #cell(phone)="data">
            <span class="hide-data capitalize">{{ data.item.phone }}</span>
          </template>

          <template #cell(email)="data">
            <a
              class="hide-data"
              :href="
                `https://mail.google.com/mail/?view=cm&fs=1&to=${data.item.email}`
              "
              target="_blank"
              >{{ data.item.email }}</a
            >
          </template>

          <template #cell(markup)="data">
            <span class="role-table">{{ data.item.type_charge | markup }}</span>
            <span>{{ data.item.mark_up }}%</span>
          </template>

          <template #cell(actions)="data">
            <ActionLink
              :basePath="'/customers'"
              :id="data.item._id"
              :canUpdate="canUserUpdate"
              :canRead="canUserRead"
              :linkClass="'icon-action ml-2'"
              :iconExtraClass="'text-primary ml-2'"
            />

            <el-tooltip
              content="Account Confirmation Email"
              placement="bottom"
              v-if="
                canUserResendEmail &&
                  !data.item.status &&
                  data.item.type !== 'guest'
              "
            >
              <span
                class="icon-action text-warning ml-2"
                @click="
                  sendEmailToConfirmAccount(
                    data.item._id,
                    data.item.email,
                    data.item.type
                  )
                "
              >
                <i class="flaticon-envelope text-warning"></i>
              </span>
            </el-tooltip>
            <el-tooltip
              content="Send password recovery email"
              placement="bottom"
              v-if="
                canUserResendEmail &&
                  data.item.status &&
                  data.item.type !== 'guest'
              "
            >
              <span
                class="icon-action text-warning ml-2"
                @click="
                  sendEmailToRecoverPassword(
                    data.item._id,
                    data.item.email,
                    data.item.type
                  )
                "
              >
                <i class="flaticon-envelope text-warning"></i>
              </span>
            </el-tooltip>

            <el-tooltip
              v-if="canUserUpdate"
              content="Change to Partner"
              placement="bottom"
            >
              <span
                class="icon-action text-info ml-2"
                @click.stop="openModalChangePartner(data.item._id)"
              >
                <i class="flaticon-support"></i>
              </span>
            </el-tooltip>

            <el-tooltip content="Delete" placement="bottom">
              <span
                class="icon-action text-danger ml-2"
                @click="deleteCostumer(data.item._id)"
                v-if="canUserDelete"
              >
                <i class="flaticon-delete"></i>
              </span>
            </el-tooltip>
          </template>
        </b-table>
        <pagination-block
          :pageCount="customerResponse.pages"
          :total="customerResponse.count"
          :limit="limit"
          @changeLimit="changeLimit"
          v-model="currentPage"
          @changePage="changePage"
          @nextPage="nextPaginations"
          @prevPage="previousPaginations"
          position="bottom"
        ></pagination-block>
      </div>
    </div>

    <ChangeToPartner
      :show="showChangePartnerModal"
      :customerId="customerId"
      :agencies="agencies"
      @customerChanged="onCustomerApproved"
      @close="ChangePartnerModal"
    />
  </section>
</template>

<script>
// @ is an alias to /src
import { mapMutations, mapGetters, mapActions } from "vuex";
import {
  CustomersAPI,
  ExportAPI,
  DocumentsAPI,
  PartnersAPI
} from "../../../core/api";
import Swal from "sweetalert2";
import moment from "moment";
import ChangeToPartner from "../components/ChangeToPartner.vue";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown
} from "element-ui";
import Pusher from "pusher-js";
import WSelect from "@/components/Select";
import {
  goBack,
  isUserAuthorized,
  ROLE_HIERARCHY,
  setSigOut
} from "../../../helpers/commons.helpers";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};
export default {
  name: "Users",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    WSelect,
    ChangeToPartner
  },
  data() {
    return {
      limit: 0,
      currentPage: 1,
      selectedRows: [],
      pusher: null,
      query: "",
      fields: [
        {
          key: "selected",
          label: "",
          sortable: false,
          class: "text-center ",
          thStyle: { minWidth: "40px" }
        },
        {
          key: "first_name",
          label: "Customer",
          sortable: true,
          thStyle: { minWidth: "150px" },
          class: "text-left"
        },

        {
          key: "type",
          label: "Type",
          sortable: true,
          thStyle: { minWidth: "100px" },
          class: "alinmov6"
        },
        {
          key: "gender",
          label: "Gender",
          sortable: true,
          thStyle: { minWidth: "80px" },
          class: "alinmov6"
        },
        {
          key: "country",
          label: "Country",
          sortable: true,
          thStyle: { minWidth: "120px" },
          class: "text-left"
        },
        {
          key: "phone",
          label: "Phone N°",
          sortable: true,
          thStyle: { minWidth: "120px" },
          class: "alinmov6"
        },
        {
          key: "email",
          label: "Email",
          sortable: true,
          thStyle: { minWidth: "150px" },
          class: "text-left"
        },
        {
          key: "markup",
          label: "Markup",
          sortable: true,
          thStyle: { minWidth: "100px" },
          class: "alinmov6"
        },

        {
          key: "actions",
          label: "Actions",
          sortable: false,
          class: "position-relative alinmov6",
          thStyle: { minWidth: "80px" }
        }
      ],
      cardview: false,
      selected: [],
      simpleSearch: "",
      sortBy: "",
      sortDesc: "asc",
      sortOptions: [
        {
          value: "full_name",
          text: "Customer Name"
        },
        {
          value: "company_name",
          text: "Business Name"
        },
        { value: "created_at", text: "Created At" }
      ],
      timeoutId: null,
      customerType: "all",
      view: "table",
      showChangePartnerModal: false,
      customerId: null,
      agencies: [],
      guides: [],
      loader: false,
      visibleSideBar: false
    };
  },
  watch: {},
  async mounted() {
    var bread = [
      {
        text: "Dashboard",
        to: "/dashboard"
      },

      {
        text: "Customers",
        active: true
      }
    ];
    this.setItemsBread(bread);
    this.agencies = await this.getPartnersOptions();
  },
  async created() {
    Pusher.logToConsole = process.env.VUE_APP_ENV === "development";
    this.pusher = new Pusher(process.env.VUE_APP_PUSHER_API_KEY, {
      cluster: process.env.VUE_APP_PUSHER_CLUSTER
    });
    this.subscribe("customers");
    await this.getLimit();
    this.limit = this.paginationLimit;
    this.currentPage = this.customerSearchCriteria.currentPage;
    this.query = this.customerSearchCriteria.query;
    this.initializeFilterData(this.query);
    this.get(true, this.limit, this.currentPage, this.query);
  },
  methods: {
    addElementInQuery(query, key, value) {
      let searchParams = new URLSearchParams(query);
      if (searchParams.has(key)) {
        searchParams.set(key, value ? value.trim() : value);
      } else {
        searchParams.append(key, value ? value.trim() : value);
      }
      return searchParams.toString();
    },
    deleteItemInQuery(query, keys = []) {
      let searchParams = new URLSearchParams(query);
      keys.forEach(key => {
        if (searchParams.has(key)) {
          searchParams.delete(key);
        }
      });
      return searchParams.toString();
    },
    changeLimit(limit) {
      if (this.limit !== limit) {
        this.limit = limit;
        this.currentPage = 1;
        this.get(true, this.limit, this.currentPage, this.query);
      }
    },
    previousPaginations(page) {
      this.get(true, this.limit, page, this.query);
    },
    nextPaginations(page) {
      this.get(true, this.limit, page, this.query);
    },
    changePage(page) {
      this.get(true, this.limit, page, this.query);
    },
    async deleteCostumer(customerId) {
      let { value } = await Swal.fire({
        title: "Delete Customer",
        text: "Are you sure do you want to delete this Customer?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",

        confirmButtonText: "Yes",

        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.deleteCostumerById(customerId);
      }
    },
    async deleteCostumerById(customerId) {
      try {
        this.setLoad(true);
        let { data } = await CustomersAPI.deleteCustomerById(
          customerId,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.data.deleted) {
          this.get(true, this.limit, 1, this.query);
        } else {
          this.$notify({
            type: "warning",
            title: "Warning!",
            message:
              "Customer cannot be deleted since it is currently assigned to a reservation.",
            icon: "flaticon-warning-1"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },

    async deleteMany() {
      let { value } = await Swal.fire({
        title: "Delete Customers",
        text: "Are you sure do you want to delete the selected Customers?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",

        confirmButtonText: "Yes",

        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.deleteManyCustomers(this.selectedRows);
      }
    },
    async deleteManyCustomers(customers = []) {
      try {
        this.setLoad(true);
        let { data } = await CustomersAPI.deleteManyCustomersById(
          { users: customers },
          this.sesion.token
        );
        this.setLoad(false);
        if (data.data.deleted) {
          this.get(true, this.limit, 1, this.query);
        } else {
          this.$notify({
            type: "warning",
            title: "Warning!",
            message:
              customers.length > 1
                ? "Customers cannot be deleted since they are currently assigned to one or many reservations."
                : "Customer cannot be deleted since it is currently assigned to a reservation.",
            icon: "flaticon-warning-1"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async download(customers = []) {
      try {
        this.setLoad(true);
        let { data } = await ExportAPI.exportCSVCustomers(
          { users: customers },
          this.sesion.token
        );
        this.setLoad(false);
        if (data.code === 200) {
          const url = window.URL.createObjectURL(new Blob([data.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `customers-${moment().format("DD-MM-YYYY")}.csv`
          );
          document.body.appendChild(link);
          link.click();
        } else {
          this.setLoad(false);
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The data was not download. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The data was not download. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    goToPreviousPage() {
      goBack(this);
    },
    handleError(error, message) {
      if (error.response) {
        let { data } = error.response;
        if (data.code === 401) {
          let auth = setSigOut(error);
          if (auth) {
            this.setSigOut(true);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: message,
          icon: "flaticon-remove"
        });
      }
    },
    async get(loader, limit, page, query) {
      this.setCustomerSearchCriteria({
        currentPage: page,
        query: query,
        limit: limit,
        status: true
      });
      this.getCustomers({
        loader: loader,
        limit: limit,
        page: page,
        query: query
      });
    },
    subscribe(event) {
      var channel = this.pusher.subscribe("rhombuss");
      channel.bind(event, data => {
        if (ROLE_HIERARCHY.includes(this.sesion.role)) {
          if (data.type === "admin") {
            this.get("init", this.pagination);
            this.showNotify(data.action);
          }
        } else {
          let owner = this.getOwner(this.sesion);
          if (data.owner === owner) {
            this.get("init", this.pagination);
            this.showNotify(data.action);
          }
        }
      });
    },
    getOwner(sesion) {
      return sesion.role === sesion.account_type.type
        ? sesion.id
        : sesion.account_type.owner;
    },
    showNotify(action) {
      if (action === "deleted") {
        this.$notify({
          type: "success",
          title: "Success!",
          message: "The Customer has been Deleted",
          icon: "flaticon-check-3"
        });
      } else if (action === "created") {
        this.$notify({
          type: "success",
          title: "Success!",
          message: "The customer has been created",
          icon: "flaticon-check-3"
        });
      }
    },
    async applySimpleSearch(value) {
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(async () => {
        if (value) {
          this.query = this.addElementInQuery(this.query, "search", value);
          this.get(true, this.limit, 1, this.query);
        } else {
          this.query = this.deleteItemInQuery(this.query, ["search"]);
          this.get(true, this.limit, 1, this.query);
        }
      }, 500);
    },
    typeSearch(type) {
      this.customerType = type;
      if (type === "all") {
        this.query = this.deleteItemInQuery(this.query, ["type"]);
        this.get(true, this.limit, 1, this.query);
      } else {
        this.query = this.addElementInQuery(this.query, "type", type);
        this.get(true, this.limit, 1, this.query);
      }
    },
    onRowSelected(selectedRows) {
      this.selectedRows = selectedRows;
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    async applySortBy(value) {
      this.query = this.addElementInQuery(this.query, "sortBy", value);
      this.query = this.addElementInQuery(
        this.query,
        "sortType",
        this.sortDesc
      );
      await this.get(true, this.limit, this.currentPage, this.query);
    },
    async applySortType(value) {
      this.query = this.addElementInQuery(this.query, "sortType", value);
      await this.get(true, this.limit, this.currentPage, this.query);
    },
    async sendEmailToConfirmAccount(customerId, email, type) {
      if (type !== "guest") {
        let { value } = await Swal.fire({
          title: "Account Confirmation Email",
          html:
            "Are you sure you want to <strong>Send</strong> an account confirmation email?",
          imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
          buttonsStyling: false,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          reverseButtons: true,
          cancelButtonText: "No",

          confirmButtonText: "Yes",

          onClose: () => {
            setTimeout(() => {}, 1500);
          }
        });
        if (value) {
          await this.sendEmailToConfirmAccountByCustomerId(customerId, email);
        }
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message:
            "The email couldn't be sent, check the customer data and try again",
          icon: "flaticon-remove"
        });
      }
    },
    async sendEmailToConfirmAccountByCustomerId(customerId, email) {
      try {
        this.setLoad(true);
        let { data } = await CustomersAPI.sendEmailToConfirmAccount(
          customerId,
          email,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The email has been sent",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message:
              "The email couldn't be sent, check the customer data and try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async sendEmailToRecoverPassword(customerId, email, type) {
      if (type !== "guest") {
        let { value } = await Swal.fire({
          title: "Password Recovery Email",
          html:
            "Are you sure you want to <strong>Send</strong> the password recovery email?",
          imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
          buttonsStyling: false,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          reverseButtons: true,
          cancelButtonText: "No",

          confirmButtonText: "Yes",

          onClose: () => {
            setTimeout(() => {}, 1500);
          }
        });
        if (value) {
          await this.sendEmailToRecoverPasswordByCustomerId(customerId, email);
        }
      } else {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Guest users are not allowed to login",
          icon: "flaticon-warning-1"
        });
      }
    },
    async sendEmailToRecoverPasswordByCustomerId(customerId, email) {
      try {
        this.setLoad(true);
        let { data } = await CustomersAPI.sendEmailToRecoverPassword(
          customerId,
          email,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The email has been sent",
            icon: "flaticon-remove"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message:
              "The email couldn't be sent, check the customer data and try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    initializeFilterData(query) {
      let searchCriteria = new URLSearchParams(query);
      this.simpleSearch = searchCriteria.has("search")
        ? searchCriteria.get("search")
        : "";
      this.customerType = searchCriteria.has("type")
        ? searchCriteria.get("type")
        : "all";
    },
    isInCustomerModule(modules = []) {
      if (!(modules.indexOf("customers") > -1)) {
        this.setCustomerSearchCriteria({
          currentPage: 1,
          limit: 15,
          query: "",
          status: false
        });
      }
    },
    closeSidebar(status) {
      this.visibleSideBar = status;
    },
    async openSideBar() {
      this.visibleSideBar = true;
      this.loader = true;
      this.guides = await this.getSupportDocuments("INTERNAL", "CUSTOMERS");
      this.loader = false;
    },
    async getSupportDocuments(app, module) {
      try {
        let { data } = await DocumentsAPI.getSupportDocuments(
          app,
          module,
          this.sesion.token
        );
        if (data.status) {
          return data.data;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    changeViewCard() {
      if (this.view === "table") {
        this.cardview = false;
      } else {
        this.cardview = true;
      }
    },
    openModalChangePartner(customerId) {
      this.customerId = customerId;
      this.showChangePartnerModal = true;
    },
    ChangePartnerModal(status) {
      this.showChangePartnerModal = status;
    },
    async onCustomerApproved(status) {
      if (status) {
        this.get(true, this.limit, this.currentPage, this.query);
        this.agencies = await this.getPartnersOptions();
      }
    },
    async getPartnersOptions() {
      try {
        let { data } = await PartnersAPI.getPartnersOptions(this.sesion.token);
        if (data.status) {
          return data.data;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    ...mapActions(["getCustomers", "getLimit"]),
    ...mapMutations([
      "setLoad",
      "setSigOut",
      "setItemsBread",
      "setCustomerSearchCriteria"
    ])
  },
  destroyed() {
    if (this.pusher !== null) {
      this.pusher.disconnect();
    }
    clearTimeout(this.timeoutId);
  },
  computed: {
    customers: function() {
      try {
        if (this.customerResponse.docs) {
          return this.customerResponse.docs;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    ...mapGetters([
      "customerResponse",
      "sesion",
      "userRole",
      "load",
      "paginationLimit",
      "customerSearchCriteria"
    ]),
    canUserUpdate() {
      return isUserAuthorized("CUSTOMERS", this.userRole, "UPDATE");
    },
    canUserDelete() {
      return isUserAuthorized("CUSTOMERS", this.userRole, "DELETE");
    },
    canUserCreate() {
      return isUserAuthorized("CUSTOMERS", this.userRole, "CREATE");
    },
    canUserRead() {
      return isUserAuthorized("CUSTOMERS", this.userRole, "READ");
    },
    canUserResendEmail() {
      return isUserAuthorized("CUSTOMERS", this.userRole, "RESEND_EMAIL");
    },
    canUserExport() {
      return isUserAuthorized("CUSTOMERS", this.userRole, "EXPORT");
    }
  },
  filters: {
    typeUser: function(type) {
      if (type === "admin") {
        return "Admin";
      } else if (type === "driver") {
        return "Driver";
      } else if (type === "suppliers") {
        return "Suppliers";
      } else if (type === "customer") {
        return "Customer";
      } else if (type === "ote") {
        return "OTE";
      } else if (type === "business") {
        return "Business";
      } else if (type === "guest") {
        return "Guest";
      } else {
        return "Client";
      }
    },
    formatGender: function(type) {
      if (type === "male") {
        return "Male";
      } else if (type === "female") {
        return "Female";
      } else if (type === "other") {
        return "Other";
      } else {
        return "";
      }
    },
    markup: function(type) {
      if (type === "commission") {
        return "Commission";
      } else {
        return "Net Price";
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    this.isInCustomerModule(to.meta.modules);
    next();
  }
};
</script>
<style lang="scss"></style>
